export default __webpack_public_path__ + "static/media/FB.536eb008.jpg";